<script>
import { mapGetters } from 'vuex'
import TitleInventoryOnline from './titleInventoryOnline'
import InventoryTable from './inventoryTable'

export default {
  name: 'OnlineInventory',
  components: { TitleInventoryOnline, InventoryTable },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      inventory_online_mode: 'retina/inventory/inventory_online_mode',
    }),
  },
  methods: {},
}
</script>
<template>
  <div v-if="inventory_online_mode">
    <div class="row mb-2">
      <div class="col-md-12 col-lg-10 col-xl-6">
        <b-card-group>
          <TitleInventoryOnline />
        </b-card-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <!-- Tabla con productos -->
        <InventoryTable />
      </div>
    </div>
  </div>
</template>
